
import { NAME } from './constants';
import { router } from './router';

export const PendingRequest = {
	name: NAME,
	router,
};
